var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHazard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2484 13.75C15.2085 13.75 15.8119 12.7346 15.3312 11.9222L9.08274 1.35899C8.60269 0.547738 7.39818 0.546266 6.91727 1.35899L0.668679 11.9222C0.18894 12.733 0.789513 13.75 1.75141 13.75H14.2484ZM6.86278 5.54029L7.05596 8.99341C7.065 9.155 7.20203 9.28149 7.36799 9.28149H8.63221C8.79817 9.28149 8.9352 9.155 8.94424 8.99341L9.13742 5.54029C9.14718 5.36575 9.00466 5.21899 8.82539 5.21899H7.17479C6.99552 5.21899 6.85302 5.36575 6.86278 5.54029ZM8.0001 9.73853C7.33851 9.73853 6.80219 10.2614 6.80219 10.9065C6.80219 11.5515 7.33851 12.0745 8.0001 12.0745C8.66169 12.0745 9.19802 11.5515 9.19802 10.9065C9.19802 10.2614 8.66169 9.73853 8.0001 9.73853Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHazard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Hazard.26b6e5a1cd0d4588b8ae743973cab69b.svg";